import React from "react";
import { motion } from "./StaticMotion";
import { FaInstagram } from "react-icons/fa";

export const Footer = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const menuItems = [
    { label: "Home", href: "#hero" },
    { label: "Who We Are", href: "#who-we-are" },
    { label: "Our Story", href: "#our-story" },
    { label: "Vision & Mission", href: "#vision-mission" },
    { label: "Services", href: "#services" },
    { label: "Testimonials", href: "#testimonials" },
    { label: "Why Choose Us", href: "#why-choose-us" },
    { label: "Contact", href: "#contact" },
  ];

  return (
    <footer className="w-full bg-white border-t border-slate-200">
      <motion.div
        className="w-full"
        style={{ marginLeft: 0 }}
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <div className="w-full max-w-6xl mx-auto py-8 px-4">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            <motion.div variants={itemVariants} className="md:col-span-5">
              <img
                src="/vionix.png"
                alt="VIONIXASIA Logo"
                className="h-16 w-auto object-contain mb-4"
              />
              <p className="text-sm max-w-lg text-slate-600">
                Integrated digital solutions that enhance efficiency, accelerate operations, and deliver a more innovative event experience.
              </p>
            </motion.div>

            <motion.div
              variants={itemVariants}
              className="md:col-span-7 flex flex-col md:flex-row md:justify-end gap-8 lg:gap-12"
            >
              <div className="flex-1 max-w-xs">
                <h4 className="text-sm font-bold mb-4 text-slate-900 uppercase tracking-wider">
                  Quick Links
                </h4>
                <div className="grid grid-cols-2 gap-x-3 gap-y-2 text-sm">
                  {menuItems.map((item, index) => (
                    <motion.a
                      key={index}
                      href={item.href}
                      className="text-slate-500 hover:text-slate-900 transition-colors duration-200"
                      whileHover={{ x: 2 }}
                      onClick={(e) => {
                        e.preventDefault();
                        const target = document.querySelector(item.href);
                        if (target) {
                          target.scrollIntoView({ behavior: "smooth" });
                        }
                      }}
                    >
                      {item.label}
                    </motion.a>
                  ))}
                </div>
              </div>

              <div className="flex flex-col items-start md:items-end min-w-fit">
                <h4 className="text-sm font-bold mb-4 text-slate-900 uppercase tracking-wider">
                  Follow Us
                </h4>
                <motion.a
                  href="https://www.instagram.com/vionixasia"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-slate-500 hover:text-slate-900 transition-colors"
                  whileHover={{ x: 2 }}
                >
                  <FaInstagram className="h-5 w-5" />
                  <span>@vionixasia</span>
                </motion.a>
              </div>
            </motion.div>
          </div>
        </div>
      </motion.div>

      <motion.div
        variants={itemVariants}
        className="w-full bg-slate-100 py-3 px-4 text-center border-t border-slate-200"
      >
        <p className="text-xs font-medium text-slate-500">
          © {new Date().getFullYear()} VIONIXASIA. All rights reserved — PT VISI EKOSISTEM DIGITAL
        </p>
      </motion.div>
    </footer>
  );
};
